export const checkBiometricAuthChanged=()=>Promise.resolve(false);export*from"./type";